RivalIQ.apps.CompanyProfile.module('views', function (views, App, Backbone, Marionette, $, _) {
    'use strict';

    views.AddPageButton = Marionette.ItemView.extend({
        template: '#addPageButtonTemplate',
        className: 'inline-block'
    });
});
